import { useEffect } from 'react';

function useResizeObserver(
    callback: (entry: ResizeObserverEntry) => void
): void {
    useEffect(() => {
        const observer = new ResizeObserver((entries) => {
            callback(entries[0]);
        });

        observer.observe(document.body);

        return (): void => {
            observer.disconnect();
        };
    }, [callback]);
}

export default useResizeObserver;
